import { z } from 'zod';
// ============================================================
// 입력 스키마 (Input Schemas)
// ============================================================
/**
 * 비밀번호 변경 입력 스키마
 */
export const changePasswordInputSchema = z.object({
    currentPassword: z.string().min(1, '현재 비밀번호는 필수입니다'),
    newPassword: z.string().min(8, '새 비밀번호는 8자 이상이어야 합니다'),
});
/**
 * 프로필 수정 입력 스키마
 */
export const updateProfileInputSchema = z.object({
    displayName: z.string().min(2, '이름은 2자 이상이어야 합니다').max(20, '이름은 20자 이하여야 합니다'),
});
/**
 * 계정 삭제 입력 스키마
 */
export const deleteAccountInputSchema = z.object({
    password: z.string().min(1, '비밀번호는 필수입니다'),
});
